import { Swiper } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

const SwiperSlider = (props) => {
	// PROPS VARIABLE
	let propsMiasto = props.miasto;
	let propsPodatek = props.podatek;

	return (
		<Swiper
			modules={[Navigation, Pagination, Scrollbar, A11y]}
			slidesPerView={1}
			slidesPerGroup={1}
			navigation
			pagination={{
				clickable: true,
				renderBullet: (index, className) =>
					`<span class="${className}"><span class="sr-only">${index + 1}</span></span>`,
			}}
			a11y={{
				firstSlideMessage: "To jest pierwszy slajd",
				prevSlideMessage: "Poprzedni slajd",
				nextSlideMessage: "Następny slajd",
				lastSlideMessage: "To jest ostatni slajd",
				paginationBulletMessage: "Idź do slajdu numer {{index}}",
			}}
		>
			{props.children}
		</Swiper>
	);
};

export default SwiperSlider;
